import React, { useContext } from "react";

import { contactLinks } from "../constants";
import { ThemeContext } from "../themeProvider";

const Contact = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div
      id="contact"
      className={darkMode ? "bg-gray-100 pt-24 min-h-screen" : "bg-black pt-24 text-white min-h-screen"}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-5xl font-bold text-center">Contact</h2>
        <div className="flex justify-between items-start flex-col md:flex-row pb-24">
          <div className="w-full md:pr-8 mt-12">
            <h3 className="text-3xl font-semibold text-blue-500 mb-4">Visit Us</h3>

            {/* Google Map */}
            <div className="w-full h-64 md:h-80 rounded-lg overflow-hidden shadow-lg mb-6">
              <iframe
                title="Geetha Furniture Location — Coimbatore"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.6346261543884!2d76.99351059999999!3d11.0168445!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba8582f3069d2f3%3A0x45f84f464eae7e34!2sGeetha%20Furniture!5e0!3m2!1sen!2sin!4v1625052345678!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            {/* Address with Schema.org microdata */}
            <address
              itemScope
              itemType="https://schema.org/PostalAddress"
              className="not-italic"
            >
              <h4 className="text-xl font-bold mb-2">Address</h4>
              <p className={darkMode ? "text-gray-700 text-lg" : "text-gray-300 text-lg"}>
                <span itemProp="streetAddress">27, opposite Vellan hollow block, Karpagam Garden, Dhanalakshmi Nagar</span>,{" "}
                <br />
                <span itemProp="addressLocality">Coimbatore</span>,{" "}
                <span itemProp="addressRegion">Tamil Nadu</span>{" "}
                <span itemProp="postalCode">641035</span>,{" "}
                <span itemProp="addressCountry">India</span>
              </p>
            </address>
          </div>

          <div className="w-full flex flex-col md:items-end mt-12 md:mt-6" style={{ paddingTop: '40px' }}>
            <h3 className="text-3xl font-bold">Phone</h3>
            <a
              href="tel:+919443017859"
              className="mb-2 mt-4 font-semibold text-blue-700 block uppercase"
              aria-label="Call Geetha Furniture at +91 9443017859"
            >
              +91 9443017859
            </a>
            <a
              href="tel:+919080420080"
              className="mb-12 font-semibold text-blue-700 block uppercase"
              aria-label="Call Geetha Furniture at +91 9080420080"
            >
              +91 9080420080
            </a>
            <h3 className="text-3xl font-bold">Email</h3>
            <a
              href="mailto:geethafurniture6@gmail.com"
              className="mb-12 mt-4 font-semibold text-blue-700 block"
              aria-label="Email Geetha Furniture"
            >
              geethafurniture6@gmail.com
            </a>
            <h3 className="text-3xl font-bold">Social</h3>
            <ul className="flex" aria-label="Social media links">
              {contactLinks.map((el, index) => (
                <li key={index}>
                  <a
                    href={el.link}
                    className="md:ml-6 md:mr-0 mr-6 cursor-pointer mt-4 hover:scale-125 flex flex-col justify-center items-center"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Geetha Furniture on Instagram"
                  >
                    <img alt="Geetha Furniture Instagram" src={el.url} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
